import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

// Componentes
import SweetAlert from "react-bootstrap-sweetalert";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import ButtonSpinner from "../../components/Buttons/ButtonSpinner";

// Services
import { updateApp } from "../../utils/services/mobileApps";
import { getFirebaseProjects } from "../../utils/services/firebaseProjects";

// Utils
import { getMenusDefault } from "./menuDefault";

export default function EditApps(props) {
  const { isOpen, toggle, editAppId, refetch, contractId } = props;
  const [isLoading, setIsloading] = useState(false);
  const { mobileApps } = useSelector((state) => state);
  const { token } = useSelector((state) => state.global_user_data.data);
  const { personalization } = useSelector((state) => state);

  const state = useSelector((state) => state);

  const [modalBackdrop, setModalBackdrop] = useState(false);

  //campos fomulário
  const [app, setApp] = useState("");
  const [bundleId, setBundleId] = useState("");
  const [termoDeAcesso, setTermoDeAcesso] = useState("");
  const [telaPrincipal, setTelaPrincipal] = useState("");
  const [checkMfa, setCheckMfa] = useState(false);
  const [checkPlayStore, setCheckPlayStore] = useState(false);
  const [checkCaptcha, setCheckCaptcha] = useState(false);
  const [checkEmailLock, setCheckEmailLock] = useState(false);
  //validações campos formulários
  const [appError, setAppError] = useState(false);
  const [bundleIdError, setBundleIdError] = useState(false);

  //editado com sucesso
  const [success, setSuccess] = useState(false);

  const [firebaseProjects, setFirebaseProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [idFirebaseProjectError, setIdFirebaseProjectError] = useState(false);

  const selectedApp = mobileApps.find((e) => e.id === editAppId);

  // state options
  const [options, setOptions] = useState([]);
  const [config, setConfig] = useState([]);

  // alterna o backdrop do modal
  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }

  // restaura os campos do formulário com os dados do app selecionado
  function resetFields() {
    setApp(selectedApp?.name);
    setBundleId(selectedApp?.bundleId);
    setTermoDeAcesso(selectedApp?.termoDeAcesso);
    setTelaPrincipal(selectedApp?.telaPrincipal);
    setAppError(false);
    setBundleIdError(false);
    setIdFirebaseProjectError(false);
  }

  // converte o nome da tela principal selecionada para o code esperado pela API
  const getCode = (value) => {
    switch (value) {
      case "Geral":
        return "GERAL";
      case "Agenda":
        return "AGENDA";
      case "Feed":
        return "FEED";
      case "Localização":
        return "LOCALIZATION";
      case "Logística":
        return "LOGISTICA";
      case "Ranking":
        return "RANKING";
      case "Convidados":
        return "CONVIDADOS";
      case "Networking":
        return "NETWORKING";
      case "Notes":
        return "NOTES";

      default:
        return "";
    }
  };

  // converte o code vindo da API de volta para o nome exibido no select
  const getListCode = (value) => {
    switch (value) {
      case "Geral":
        return "GERAL";
      case "AGENDA":
        return "Agenda";
      case "FEED":
        return "Feed";
      case "LOCALIZATION":
        return "Localização";
      case "LOGISTICA":
        return "Logística";
      case "RANKING":
        return "Ranking";
      case "CONVIDADOS":
        return "CONVIDADOS";
      case "NETWORKING":
        return "Networking";
      case "NOTES":
        return "Notes";

      default:
        return "";
    }
  };
  // envia os dados atualizados do app para a API
  async function updateMobileApps() {
    const data = {
      name: app,
      bundleId: bundleId,
      idFirebaseProject: selectedProject,
      enabled: true,
      contractId,
      termoDeAcesso: termoDeAcesso,
      telaPrincipal: telaPrincipal === "Selecione" ? "" : telaPrincipal,
      hasMfa: checkMfa,
      hasRecaptcha: checkCaptcha,
      hasAppintegrity: checkPlayStore,
      hasRecoveryPasswordSecure: checkEmailLock,
    };
    setIsloading(true);
    updateApp({ jwt: token, id: editAppId, data })
      .then((response) => {
        setIsloading(false);

        setSuccess(true);
        refetch();
        // resetFields();
      })
      .catch((error) => {
        setIsloading(false);
        console.log(error);
      });
  }

  // valida os campos obrigatórios e envia a edição do app
  function submitForm() {
    if (app === "") {
      return setAppError(true);
    } else setAppError(false);
    if (!selectedProject || selectedProject === "Selecione") {
      return setIdFirebaseProjectError(true);
    } else setIdFirebaseProjectError(false);

    if (bundleId === "") {
      return setBundleIdError(true);
    } else setBundleIdError(false);

    updateMobileApps();
    // resetFields();
  }

  // carrega as opções de tela principal disponíveis
  function getMenus() {
    const newOptions = getMenusDefault();
    setOptions([...newOptions]);
  }

  useEffect(() => {
    if (editAppId) {
      getMenus();
      setApp(selectedApp?.name);
      setBundleId(selectedApp?.bundleId);
      setTermoDeAcesso(selectedApp?.termoDeAcesso);
      setTelaPrincipal(selectedApp?.telaPrincipal);
      setCheckCaptcha(selectedApp.hasRecaptcha);
      setCheckMfa(selectedApp.hasMfa);
      setCheckPlayStore(selectedApp.hasAppintegrity);
      setCheckEmailLock(selectedApp.hasRecoveryPasswordSecure ?? false);
    }
  }, [mobileApps, editAppId, selectedApp]);

  useEffect(() => {
    if (isOpen) {
      getFBProjects();
      setSelectedProject(selectedApp.idFirebaseProject);
      return;
    }
    setSelectedProject(null);
  }, [isOpen]);

  // busca os projetos do Firebase disponíveis para vincular ao app
  function getFBProjects() {
    getFirebaseProjects({ jwt: token }).then((res) => {
      setFirebaseProjects(res.findAll.data);
    });
  }

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      toggle={() => {
        toggleBackdrop();
      }}
      onClosed={() => {
        resetFields();
      }}
      autoFocus={true}
      centered={true}
    >
      {success && (
        <SweetAlert
          success
          title="Edição"
          onConfirm={() => {
            setSuccess(false);
            toggle();
          }}
        >
          App editado com sucesso!
        </SweetAlert>
      )}
      <ModalHeader toggle={toggle}>Editar App</ModalHeader>
      <ModalBody>
        <form onSubmit={(e) => e.preventDefault()}>
          <Row style={{ marginTop: 10 }}>
            <Col>
              <label className="form-label">ID do App</label>
              <input
                className="form-control"
                type="text"
                value={selectedApp?.id ? selectedApp.id : null}
                disabled
              />
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col>
              <label className="form-label text-sm" style={{ display: "flex" }}>
                Nome do Aplicativo*
                <div
                  id="nameApp"
                  style={{ height: "16px", paddingRight: "7px" }}
                >
                  <div className="show-tips">
                    <span>?</span>
                  </div>
                  <UncontrolledTooltip
                    style={{ backgroundColor: "#6f42c1" }}
                    placement="right"
                    target="nameApp"
                  >
                    Nome que será exibido nas lojas e no dispositivo do usuário
                    quando o APP for baixado
                  </UncontrolledTooltip>
                </div>
              </label>{" "}
              <input
                className="form-control"
                type="text"
                value={app}
                onChange={(e) => setApp(e.target.value)}
              />
              {appError && (
                <span style={{ color: "red" }}>
                  O campo Nome do Aplicativo é obrigatório.
                </span>
              )}
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col>
              <label className="form-label text-sm" style={{ display: "flex" }}>
                ID do Projeto (Firebase)*
                <div
                  id="projectId"
                  style={{ height: "16px", paddingRight: "7px" }}
                >
                  <div className="show-tips">
                    <span>?</span>
                  </div>
                  <UncontrolledTooltip
                    style={{ backgroundColor: "#6f42c1" }}
                    placement="right"
                    target="projectId"
                  >
                    Projeto do Firebase que será responsável por enviar os pushs
                    e guardar as informações do chat individual, anotações,
                    super tela
                  </UncontrolledTooltip>
                </div>
              </label>
              <select
                className="form-control"
                onChange={(e) => {
                  setSelectedProject(e.target.value);
                }}
              >
                <option>Selecione</option>
                {firebaseProjects &&
                  firebaseProjects?.map((e, i) => (
                    <option
                      selected={
                        selectedApp?.idFirebaseProject === e.name ? true : false
                      }
                      key={i}
                    >
                      {e.name}
                    </option>
                  ))}
              </select>
              {idFirebaseProjectError && (
                <span style={{ color: "red" }}>
                  O campo ID do Projeto (Firebase) é obrigatório.
                </span>
              )}
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col>
              <label className="form-label text-sm" style={{ display: "flex" }}>
                Bundle ID*
                <div
                  id="bundleId"
                  style={{ height: "16px", paddingRight: "7px" }}
                >
                  <div className="show-tips">
                    <span>?</span>
                  </div>
                  <UncontrolledTooltip
                    style={{ backgroundColor: "#6f42c1" }}
                    placement="right"
                    target="bundleId"
                  >
                    Código identificador do APP nas lojas
                  </UncontrolledTooltip>
                </div>
              </label>{" "}
              <input
                className="form-control"
                type="text"
                value={bundleId}
                onChange={(e) => setBundleId(e.target.value)}
              />
              {bundleIdError && (
                <span style={{ color: "red" }}>
                  O campo Bundle ID é obrigatório.
                </span>
              )}
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col>
              <label className="form-label text-sm" style={{ display: "flex" }}>
                Termo de Acesso
                <div id="term" style={{ height: "16px", paddingRight: "7px" }}>
                  <div className="show-tips">
                    <span>?</span>
                  </div>
                  <UncontrolledTooltip
                    style={{ backgroundColor: "#6f42c1" }}
                    placement="right"
                    target="term"
                  >
                    Termo de acesso que será carregado ao clicar no link da tela
                    de login, caso deixe o campo em branco o aplicativo exibirá
                    a politica de privacidade da Inteegra
                  </UncontrolledTooltip>
                </div>
              </label>{" "}
              <input
                className="form-control"
                type="text"
                value={termoDeAcesso}
                onChange={(e) => setTermoDeAcesso(e.target.value)}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: 10, marginBottom: 20 }}>
            <Col lg={12}>
              <label className="form-label text-sm" style={{ display: "flex" }}>
                Tela Principal
                <div
                  id="mainScreen"
                  style={{ height: "16px", paddingRight: "7px" }}
                >
                  <div className="show-tips">
                    <span>?</span>
                  </div>
                  <UncontrolledTooltip
                    style={{ backgroundColor: "#6f42c1" }}
                    placement="right"
                    target="mainScreen"
                  >
                    Tela que será exibida ao abrir o aplicativo quando o
                    participante tiver apenas 1 evento
                  </UncontrolledTooltip>
                </div>
              </label>{" "}
              <select
                className="form-control"
                value={getListCode(telaPrincipal)}
                onChange={({ target }) =>
                  setTelaPrincipal(getCode(target.value))
                }
              >
                {/* <option>Selecione</option> */}
                {/* <option>Geral</option> */}
                {options &&
                  options
                    .filter(
                      (e) =>
                        !config.find(
                          (a) => a.code === e.option || a.code === e.code,
                        ),
                    )
                    .map((e, i) => (
                      <option key={i}>{e?.describe || e.option}</option>
                    ))}
              </select>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <label style={{ fontSize: 17 }}>Requisitos de Segurança</label>
            </Col>
          </Row>

          <Row>
            <Col md={12} style={{ display: "flex", flexDirection: "column" }}>
              <div className="form-check form-switch mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkMfa"
                  checked={checkMfa}
                  onChange={(e) => setCheckMfa(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="checkMfa">
                  Habilitar MFA no Login
                </label>
              </div>

              <div className="form-check form-switch mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkPlayStore"
                  checked={checkPlayStore}
                  onChange={(e) => setCheckPlayStore(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="checkPlayStore">
                  Habilitar Integridade (Play Store)
                </label>
              </div>

              <div className="form-check form-switch mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkCaptcha"
                  checked={checkCaptcha}
                  onChange={(e) => setCheckCaptcha(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="checkCaptcha">
                  Habilitar CAPTCHA
                </label>
              </div>

              <div className="form-check form-switch mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkEmailLock"
                  checked={checkEmailLock}
                  onChange={(e) => setCheckEmailLock(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="checkEmailLock">
                  Retirar trava de email inválido do esqueceu senha
                </label>
              </div>
            </Col>
          </Row>

          <Row
            style={{
              width: "100%",
              marginTop: 15,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              color="success"
              className="btn btn-danger waves-effect waves-light"
              style={{ width: 80, marginRight: 5 }}
              onClick={() => toggle()}
            >
              Fechar
            </Button>
            <ButtonSpinner
              isLoading={isLoading}
              title={"Salvar"}
              onClick={submitForm}
              isDisabled={personalization?.login?.toggleError || false}
              action={"U"}
            />
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
}
